export default {
  on: {
    pageInit: function () {
      var amtInput = document.getElementById('amount');
      var feeRow = document.getElementById('wdFeeRow');
      var reqAmt = document.getElementById('wdReqAmt');
      var feeAmt = document.getElementById('wdFeeAmt');
      var netAmt = document.getElementById('wdNetAmt');
      var submitSub = document.getElementById('wdSubmitSub');
      var submitNet = document.getElementById('wdSubmitNet');
      function usd(n) {
        return '$' + Number(n).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
      }
      var feePct = 5;
      var exitFee = 0, exitPct = 0;
      var exitRow = document.getElementById('wdExitRow');
      var exitAmt = document.getElementById('wdExitAmt');
      var exitPctEl = document.querySelector('.wd-exit-pct');
      function renderFee() {
        if (!amtInput)
          return;
        var val = parseFloat(amtInput.value);
        if (!isNaN(val) && val > 0) {
          var fee = val * (feePct / 100);
          var exit = Math.min(exitFee, Math.max(0, val - fee));
          var net = val - fee - exit;
          reqAmt.textContent = usd(val);
          feeAmt.textContent = '\u2212' + usd(fee);
          if (exitRow) {
            exitRow.style.display = exit > 0 ? 'flex' : 'none';
            if (exitAmt)
              exitAmt.textContent = '\u2212' + usd(exit);
            if (exitPctEl)
              exitPctEl.textContent = exitPct > 0 ? '(' + exitPct + '%)' : '';
          }
          netAmt.textContent = usd(net);
          feeRow.style.display = 'block';
          submitNet.textContent = usd(net);
          submitSub.style.display = '';
        } else {
          feeRow.style.display = 'none';
          submitSub.style.display = 'none';
        }
      }
      window.wdSetFee = function (pct) {
        var p = parseFloat(pct);
        if (!isNaN(p)) {
          feePct = p;
          renderFee();
        }
      };
      window.wdSetEarlyExit = function (fee, pct) {
        exitFee = parseFloat(fee) || 0;
        exitPct = parseFloat(pct) || 0;
        renderFee();
      };
      var pctBtns = document.querySelectorAll('.wd__pct');
      function syncPcts() {
        var max = parseFloat(amtInput && amtInput.getAttribute('max')) || 0;
        var val = parseFloat(amtInput && amtInput.value);
        for (var i = 0; i < pctBtns.length; i++) {
          var p = parseFloat(pctBtns[i].getAttribute('data-pct'));
          var target = max > 0 ? Math.floor(max * p) / 100 : NaN;
          pctBtns[i].classList.toggle('wd__pct--on', !isNaN(val) && !isNaN(target) && Math.abs(val - target) < 0.005);
        }
      }
      for (var pi = 0; pi < pctBtns.length; pi++) {
        pctBtns[pi].addEventListener('click', function () {
          var max = parseFloat(amtInput.getAttribute('max')) || 0;
          if (!(max > 0))
            return;
          var p = parseFloat(this.getAttribute('data-pct'));
          amtInput.value = Math.floor(max * p) / 100;
          amtInput.dispatchEvent(new Event('input', { bubbles: true }));
        });
      }
      if (amtInput)
        amtInput.addEventListener('input', function () {
          renderFee();
          syncPcts();
        });
    }
  },
  id: '8e3c9ace38',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\r\n  <div class="page wd" data-name="invest-withdraw">\r\n\r\n    <!-- Navbar -->\r\n    <div class="navbar wd__navbar no-shadow">\r\n      <div class="navbar-bg"></div>\r\n      <div class="navbar-inner">\r\n        <div class="left">\r\n          <a href="#" class="link back wd__back" aria-label="Back">\r\n            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><polyline points="15 18 9 12 15 6"/></svg>\r\n          </a>\r\n        </div>\r\n        <div class="title wd__navbar-title">Withdraw</div>\r\n        <div class="right"></div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class="page-content wd__content">\r\n\r\n      <!-- \u2500\u2500 Unavailable gate (closed day / nothing withdrawable) \u2500\u2500 -->\r\n      <div class="wd__gate" style="display:none;">\r\n        <div class="wd__gate-card">\r\n          <span class="wd__gate-halo"></span>\r\n          <div class="wd__gate-icon">\r\n            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#ff6b5c" stroke-width="1.6" stroke-linecap="round"><circle cx="12" cy="12" r="9.5"/><line x1="5.3" y1="5.3" x2="18.7" y2="18.7"/></svg>\r\n          </div>\r\n          <h2 class="wd__gate-title">Withdrawal Unavailable</h2>\r\n          <p class="wd__gate-sub">Withdrawals are currently not available.</p>\r\n          <a href="/invest/" class="wd__gate-cta" style="display:none;">\r\n            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.3"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>\r\n            Start Investing\r\n          </a>\r\n        </div>\r\n      </div>\r\n\r\n      <!-- \u2500\u2500 Withdrawal body \u2500\u2500 -->\r\n      <div class="wd__body">\r\n\r\n        <!-- Balance hero -->\r\n        <div class="wd__balance">\r\n          <span class="wd__balance-shine"></span>\r\n          <div class="wd__balance-glow"></div>\r\n          <div class="wd__balance-top">\r\n            <span class="wd__balance-label">\r\n              <span class="wd__balance-label-ico">\r\n                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><path d="M21 12V7H5a2 2 0 0 1 0-4h14v4"/><path d="M3 5v14a2 2 0 0 0 2 2h16v-5"/><path d="M18 12a2 2 0 0 0 0 4h4v-4z"/></svg>\r\n              </span>\r\n              Withdrawable Balance\r\n            </span>\r\n            <span class="wd__balance-live"><span class="wd__balance-live-dot"></span>Live</span>\r\n          </div>\r\n          <div class="wd__balance-amount wallet--amount">$0.00</div>\r\n          <div class="wd__balance-note wd-balST">Withdrawal opens once your balance reaches the minimum threshold.</div>\r\n          <div class="wd__balance-foot">\r\n            <span class="wd__balance-tag">\r\n              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 15 14"/></svg>\r\n              <span class="wd__withdraw-days">Mon\u2013Fri</span>\r\n            </span>\r\n            <span class="wd__balance-tag">\r\n              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>\r\n              Secure payout\r\n            </span>\r\n            <span class="wd__balance-tag">\r\n              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>\r\n              24h settlement\r\n            </span>\r\n          </div>\r\n        </div>\r\n\r\n        <form name="investWithFrm" id="investWithFrm" method="post" action="" autocomplete="off">\r\n          <input type="hidden" name="wallet">\r\n          <input type="hidden" name="method" id="wdMethod" value="crypto">\r\n          <input type="hidden" name="network" id="wdNetwork" value="">\r\n          <input type="hidden" name="beneficiaryID" id="wdBeneficiaryID" value="">\r\n          <input type="hidden" name="withdrawType" id="wdType" value="investment">\r\n\r\n          <!-- Step 1 \xB7 source + amount -->\r\n          <div class="wd__sec-title"><span class="wd__step-n">1</span>What to Withdraw</div>\r\n          <div class="wd__card">\r\n            <!-- Source segmented control -->\r\n            <div class="wd__field">\r\n              <label class="wd__field-lbl">Withdraw From</label>\r\n              <div class="wd__src">\r\n                <button type="button" class="wd__src-tab wd__src-tab--on" data-src="investment">\r\n                  <span class="wd__src-ico"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><polyline points="22 7 13.5 15.5 8.5 10.5 2 17"/><polyline points="16 7 22 7 22 13"/></svg></span>\r\n                  <span class="wd__src-name">Returns</span>\r\n                </button>\r\n                <button type="button" class="wd__src-tab" data-src="commission">\r\n                  <span class="wd__src-ico"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><circle cx="18" cy="5" r="2.6"/><circle cx="6" cy="12" r="2.6"/><circle cx="18" cy="19" r="2.6"/><line x1="8.6" y1="13.5" x2="15.4" y2="17.5"/><line x1="15.4" y1="6.5" x2="8.6" y2="10.5"/></svg></span>\r\n                  <span class="wd__src-name">Commission</span>\r\n                </button>\r\n                <button type="button" class="wd__src-tab wd__src-tab--disabled" data-src="principal">\r\n                  <span class="wd__src-ico"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><rect x="3" y="7.5" width="18" height="12.5" rx="2"/><path d="M8 7.5V5.5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><line x1="3" y1="12.5" x2="21" y2="12.5"/></svg></span>\r\n                  <span class="wd__src-name">Capital</span>\r\n                </button>\r\n              </div>\r\n            </div>\r\n\r\n            <!-- Investment selector (returns + capital sources) -->\r\n            <div class="wd__field wd__inv-field">\r\n              <label class="wd__field-lbl">Select Investment</label>\r\n              <select name="investmentSelect" id="investmentSelect"></select>\r\n            </div>\r\n\r\n            <!-- Capital summary \u2014 full amount only, charges shown up front -->\r\n            <div class="wd__field wd__prin-field" style="display:none;">\r\n              <label class="wd__field-lbl">Capital to Return</label>\r\n              <div class="wd__prin">\r\n                <div class="wd__prin-row">\r\n                  <span class="wd__prin-lbl">Principal amount</span>\r\n                  <b class="wd__prin-val wd-prin-amount">$0.00</b>\r\n                </div>\r\n                <div class="wd__prin-row wd-prin-fee-row" style="display:none;">\r\n                  <span class="wd__prin-lbl">Early-exit charge <em class="wd-prin-feepct"></em></span>\r\n                  <span class="wd__prin-val wd__prin-val--fee wd-prin-fee">\u2212$0.00</span>\r\n                </div>\r\n                <div class="wd__prin-note wd-prin-note">The principal must be withdrawn in full.</div>\r\n              </div>\r\n            </div>\r\n\r\n            <!-- Commission balance -->\r\n            <div class="wd__field wd__comm-field" style="display:none;">\r\n              <label class="wd__field-lbl">Network Commission</label>\r\n              <div class="wd__comm-box">\r\n                <span class="wd__comm-ico"><svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><circle cx="18" cy="5" r="2.6"/><circle cx="6" cy="12" r="2.6"/><circle cx="18" cy="19" r="2.6"/><line x1="8.6" y1="13.5" x2="15.4" y2="17.5"/><line x1="15.4" y1="6.5" x2="8.6" y2="10.5"/></svg></span>\r\n                <span class="wd__comm-txt">Available commission balance</span>\r\n                <b class="wd__comm-val wd-commission-bal">$0.00</b>\r\n              </div>\r\n            </div>\r\n\r\n            <!-- Amount -->\r\n            <div class="wd__field" style="margin-bottom:0;">\r\n              <label class="wd__field-lbl">Enter Amount</label>\r\n              <div class="wd__amount">\r\n                <span class="wd__amount-cur">$</span>\r\n                <input type="number" name="amount" id="amount" class="wd__amount-input" min="10" placeholder="0.00" required validate>\r\n                <button type="button" class="wd__amount-max">MAX</button>\r\n                <!-- shown instead of MAX for a capital return, where the amount is fixed -->\r\n                <span class="wd__amount-lock" style="display:none;" aria-hidden="true">\r\n                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>\r\n                  Fixed\r\n                </span>\r\n              </div>\r\n              <p class="wd__amount-hint" style="display:none;">\r\n                The full principal must be returned in one go, so this amount can\u2019t be edited.\r\n              </p>\r\n              <!-- quick fractions of the available balance -->\r\n              <div class="wd__pcts">\r\n                <button type="button" class="wd__pct" data-pct="25">25%</button>\r\n                <button type="button" class="wd__pct" data-pct="50">50%</button>\r\n                <button type="button" class="wd__pct" data-pct="75">75%</button>\r\n                <button type="button" class="wd__pct" data-pct="100">All</button>\r\n              </div>\r\n\r\n              <!-- receipt-style breakdown -->\r\n              <div class="wd__fee-row" id="wdFeeRow" style="display:none;">\r\n                <div class="wd__fee-line">\r\n                  <span class="wd__fee-line-lbl">Withdrawal Amount</span>\r\n                  <span class="wd__fee-line-val" id="wdReqAmt">$0.00</span>\r\n                </div>\r\n                <div class="wd__fee-line">\r\n                  <span class="wd__fee-line-lbl">Processing Fee <em class="wd__fee-em wd-fee-pct">5%</em></span>\r\n                  <span class="wd__fee-line-val wd__fee-line-val--fee" id="wdFeeAmt">\u2212$0.00</span>\r\n                </div>\r\n                <!-- capital returned before the cycle completes carries an extra plan charge -->\r\n                <div class="wd__fee-line" id="wdExitRow" style="display:none;">\r\n                  <span class="wd__fee-line-lbl">Early-exit Charge <em class="wd__fee-em wd-exit-pct"></em></span>\r\n                  <span class="wd__fee-line-val wd__fee-line-val--fee" id="wdExitAmt">\u2212$0.00</span>\r\n                </div>\r\n                <div class="wd__fee-divider"></div>\r\n                <div class="wd__fee-line wd__fee-line--net">\r\n                  <span class="wd__fee-line-lbl wd__fee-line-lbl--net">\r\n                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>\r\n                    You Receive\r\n                  </span>\r\n                  <span class="wd__fee-line-val wd__fee-line-val--net" id="wdNetAmt">$0.00</span>\r\n                </div>\r\n              </div>\r\n              <div class="wd__inr" style="display:none;">\r\n                <span class="wd__inr-amt">\u2248 <b class="wd-payableINR">\u20B90</b></span>\r\n                <span class="wd__inr-rate">1 USD = \u20B9<span class="wd-usdInrRate">\u2014</span></span>\r\n              </div>\r\n            </div>\r\n          </div>\r\n\r\n          <!-- Step 2 \xB7 destination -->\r\n          <div class="wd__sec-title"><span class="wd__step-n">2</span>Where It Goes</div>\r\n          <div class="wd__card">\r\n            <div class="wd__methods">\r\n              <!-- \u2500\u2500 Bank (hidden \u2014 re-enable when Bank withdrawals are available)\r\n              <button type="button" class="wd__method" data-method="bank" data-scope="IN">\r\n                <span class="wd__method-ico"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 21 7 3 7"/><line x1="6" y1="10" x2="6" y2="17"/><line x1="10" y1="10" x2="10" y2="17"/><line x1="14" y1="10" x2="14" y2="17"/><line x1="18" y1="10" x2="18" y2="17"/><line x1="4" y1="20" x2="20" y2="20"/></svg></span>\r\n                <span class="wd__method-name">Bank</span>\r\n                <span class="wd__method-tag">India</span>\r\n              </button>\r\n              \u2500\u2500 End Bank \u2500\u2500 -->\r\n              <!-- \u2500\u2500 UPI (hidden \u2014 re-enable when UPI withdrawals are available)\r\n              <button type="button" class="wd__method" data-method="upi" data-scope="IN">\r\n                <span class="wd__method-ico"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/></svg></span>\r\n                <span class="wd__method-name">UPI</span>\r\n                <span class="wd__method-tag">India</span>\r\n              </button>\r\n              \u2500\u2500 End UPI \u2500\u2500 -->\r\n              <button type="button" class="wd__method wd__method--on" data-method="crypto" data-scope="ALL">\r\n                <span class="wd__method-ico wd__method-ico--logo"><img src="assets/icons/usdt-bep20.png" alt="USDT"></span>\r\n                <span class="wd__method-body">\r\n                  <span class="wd__method-name">USDT</span>\r\n                  <span class="wd__method-tag">BEP-20 \xB7 Binance Smart Chain</span>\r\n                </span>\r\n                <span class="wd__method-check">\r\n                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.4"><polyline points="20 6 9 17 4 12"/></svg>\r\n                </span>\r\n              </button>\r\n            </div>\r\n\r\n            <!-- Saved payout accounts for the active method (rendered by routes.js) -->\r\n            <div class="wd__payout">\r\n              <div class="wd__payout-head">\r\n                <span class="wd__payout-title">Payout Account</span>\r\n              </div>\r\n              <div class="wd__bene-list"></div>\r\n              <div class="wd__bene-form-wrap"></div>\r\n            </div>\r\n          </div>\r\n\r\n          <p class="wd__timetxt w-timetxt"></p>\r\n        </form>\r\n\r\n        <button type="button" class="withdrawMoney wd__submit disabled">\r\n          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><line x1="12" y1="19" x2="12" y2="5"/><polyline points="5 12 12 5 19 12"/></svg>\r\n          <span class="wd__submit-body">\r\n            <span class="wd__submit-txt">Request Withdrawal</span>\r\n            <span class="wd__submit-sub" id="wdSubmitSub" style="display:none;">You\u2019ll receive <b id="wdSubmitNet">$0.00</b></span>\r\n          </span>\r\n        </button>\r\n\r\n        <!-- Compatible BEP-20 wallets (auto-scroll marquee) -->\r\n        <div class="wd__wallets">\r\n          <div class="wd__wallets-head">\r\n            <span class="wd__wallets-ico">\r\n              <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M21 12V7H5a2 2 0 0 1 0-4h14v4"/><path d="M3 5v14a2 2 0 0 0 2 2h16v-5"/><path d="M18 12a2 2 0 0 0 0 4h4v-4z"/></svg>\r\n            </span>\r\n            <div class="wd__wallets-head-txt">\r\n              <span class="wd__wallets-title">Compatible Wallets</span>\r\n              <span class="wd__wallets-sub">Withdraw USDT to your <b>BEP-20</b> address on any of these</span>\r\n            </div>\r\n          </div>\r\n          <div class="wd__wallets-marquee">\r\n            <div class="wd__wallets-track">\r\n              <!-- set 1 -->\r\n              <span class="wd__wallet"><img class="wd__wallet-logo" src="assets/icons/trust-wallet-icon.svg" alt="Trust Wallet"><span class="wd__wallet-name">Trust Wallet</span></span>\r\n              <span class="wd__wallet"><img class="wd__wallet-logo" src="assets/icons/metamask-icon.svg" alt="MetaMask"><span class="wd__wallet-name">MetaMask</span></span>\r\n              <span class="wd__wallet"><img class="wd__wallet-logo" src="assets/icons/safepal-wallet.svg" alt="SafePal"><span class="wd__wallet-name">SafePal</span></span>\r\n              <span class="wd__wallet"><img class="wd__wallet-logo" src="assets/icons/binance-coin-bnb-icon.svg" alt="Binance"><span class="wd__wallet-name">Binance</span></span>\r\n              <span class="wd__wallet"><img class="wd__wallet-logo" src="assets/icons/coinbase-logo-icon.svg" alt="Coinbase"><span class="wd__wallet-name">Coinbase</span></span>\r\n              <!-- set 2 (duplicate \u2192 seamless loop) -->\r\n              <span class="wd__wallet" aria-hidden="true"><img class="wd__wallet-logo" src="assets/icons/trust-wallet-icon.svg" alt=""><span class="wd__wallet-name">Trust Wallet</span></span>\r\n              <span class="wd__wallet" aria-hidden="true"><img class="wd__wallet-logo" src="assets/icons/metamask-icon.svg" alt=""><span class="wd__wallet-name">MetaMask</span></span>\r\n              <span class="wd__wallet" aria-hidden="true"><img class="wd__wallet-logo" src="assets/icons/safepal-wallet.svg" alt=""><span class="wd__wallet-name">SafePal</span></span>\r\n              <span class="wd__wallet" aria-hidden="true"><img class="wd__wallet-logo" src="assets/icons/binance-coin-bnb-icon.svg" alt=""><span class="wd__wallet-name">Binance</span></span>\r\n              <span class="wd__wallet" aria-hidden="true"><img class="wd__wallet-logo" src="assets/icons/coinbase-logo-icon.svg" alt=""><span class="wd__wallet-name">Coinbase</span></span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <!-- Withdrawal rules \u2014 one icon per rule reads far faster than a paragraph block -->\r\n        <div class="wd__info">\r\n          <div class="wd__rule">\r\n            <span class="wd__rule-ico">\r\n              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><rect x="2" y="5" width="20" height="14" rx="2.5"/><line x1="2" y1="10" x2="22" y2="10"/></svg>\r\n            </span>\r\n            <span class="wd__rule-txt">You can only withdraw to a <b>saved payout account</b>. Funds are sent to your saved <b>USDT (BEP-20)</b> address.</span>\r\n          </div>\r\n          <div class="wd__rule">\r\n            <span class="wd__rule-ico">\r\n              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 15 14"/></svg>\r\n            </span>\r\n            <span class="wd__rule-txt">Requests are accepted <b class="wd__withdraw-days">Mon\u2013Fri</b>; daily ROI is credited <b class="wd__payout-days">Mon\u2013Fri</b>. Funds settle within <b>24 hours</b> of approval.</span>\r\n          </div>\r\n          <div class="wd__rule">\r\n            <span class="wd__rule-ico">\r\n              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>\r\n            </span>\r\n            <span class="wd__rule-txt">Minimum withdrawal <b class="wd-min-amt">$10.00</b>. A <b><span class="wd-fee-pct">5%</span> processing fee</b> is deducted from the requested amount.</span>\r\n          </div>\r\n          <div class="wd__rule">\r\n            <span class="wd__rule-ico">\r\n              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>\r\n            </span>\r\n            <span class="wd__rule-txt"><b>Capital return</b> pays back your principal and must be taken in full. Where a plan locks it, capital is released once the return cycle completes.</span>\r\n          </div>\r\n        </div>\r\n\r\n      </div>\r\n      <div class="wd__end-gap"></div>\r\n    </div>\r\n  </div>\r\n';
      return r;
    }(this);
  },
  style: `
/* ════════ WITHDRAW PAGE (wd__*) ════════ */
.wd { background: #0A0A0B !important; }
.wd__content {
  background:
    radial-gradient(130% 45% at 50% 0%, rgba(201,169,105,0.10) 0%, transparent 56%),
    #0A0A0B !important;
  padding: 14px 14px calc(40px + env(safe-area-inset-bottom)) !important;
  margin-top: 60px !important;
}
.wd__navbar { background: linear-gradient(180deg, #100E09 0%, #0B0A07 100%) !important; }
.wd__navbar .navbar-bg { background: transparent !important; }
.wd__navbar-title { color: var(--gold) !important; font-weight: 700; }
.wd__back { color: rgba(201,169,105,0.85) !important; }

/* ── Gate (premium block) ── */
.wd__gate { padding: 30px 6px; }
.wd__gate-card {
  position: relative; overflow: hidden; text-align: center;
  background: linear-gradient(160deg, #181410 0%, #121010 100%);
  border: 1px solid rgba(255,255,255,0.07);
  border-radius: 24px; padding: 40px 26px 34px;
  box-shadow: inset 0 1px 0 rgba(255,255,255,0.05), 0 22px 50px -26px rgba(0,0,0,0.85);
}
.wd__gate-halo {
  position: absolute; top: -60px; left: 50%; transform: translateX(-50%);
  width: 200px; height: 200px; border-radius: 50%; pointer-events: none;
  background: radial-gradient(circle, rgba(255,107,92,0.16), transparent 65%);
}
.wd__gate-icon {
  position: relative; z-index: 1;
  width: 80px; height: 80px; border-radius: 50%; margin: 0 auto 20px;
  background: radial-gradient(circle, rgba(255,107,92,0.16), rgba(255,107,92,0.04));
  border: 1.5px solid rgba(255,107,92,0.30);
  display: flex; align-items: center; justify-content: center;
  box-shadow: 0 0 0 8px rgba(255,107,92,0.05);
}
.wd__gate-title { position: relative; z-index: 1; font-size: 20px; font-weight: 800; color: #fff; margin: 0; letter-spacing: -0.01em; }
.wd__gate-sub { position: relative; z-index: 1; font-size: 13px; color: rgba(255,255,255,0.52); margin: 10px auto 0; line-height: 1.6; max-width: 290px; }
.wd__gate-cta {
  position: relative; z-index: 1;
  display: inline-flex; align-items: center; gap: 7px; margin-top: 22px;
  padding: 12px 24px; border-radius: 13px;
  background: linear-gradient(135deg, #f3da92 0%, #C9A969 45%, #a07c38 100%);
  color: #1a1206; font-size: 14px; font-weight: 800;
  box-shadow: 0 10px 26px -8px rgba(201,169,105,0.6), inset 0 1px 0 rgba(255,255,255,0.4);
}
.wd__gate-cta:active { transform: scale(0.97); }

/* ── Balance hero ── */
.wd__balance {
  position: relative; overflow: hidden;
  margin-top: 14px; padding: 18px 18px 15px; border-radius: 22px;
  background:
    radial-gradient(120% 90% at 50% -20%, rgba(201,169,105,0.22) 0%, transparent 60%),
    linear-gradient(158deg, #221b0d 0%, #16110a 55%, #1a150c 100%);
  border: 1px solid rgba(201,169,105,0.30);
  box-shadow: inset 0 1px 0 rgba(223,194,136,0.22), 0 20px 42px -24px rgba(0,0,0,0.9);
}
.wd__balance::before {
  content: ''; position: absolute; top: 0; left: 10%; right: 10%; height: 1px;
  background: linear-gradient(90deg, transparent, rgba(223,194,136,0.75), transparent);
}
.wd__balance-glow {
  position: absolute; top: -70px; right: -50px; width: 190px; height: 190px;
  border-radius: 50%; pointer-events: none;
  background: radial-gradient(circle, rgba(201,169,105,0.20), transparent 66%);
}
@keyframes wd-shine { 0% { transform: translateX(-130%) skewX(-18deg); } 100% { transform: translateX(430%) skewX(-18deg); } }
.wd__balance-shine { position: absolute; inset: 0; overflow: hidden; border-radius: 22px; pointer-events: none; }
.wd__balance-shine::after {
  content: ''; position: absolute; top: 0; bottom: 0; width: 42%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.06), transparent);
  animation: wd-shine 5.5s ease-in-out infinite 1.4s;
}
.wd__balance-top { position: relative; z-index: 1; display: flex; align-items: center; justify-content: space-between; gap: 10px; }
.wd__balance-label {
  display: inline-flex; align-items: center; gap: 7px;
  font-size: 11px; font-weight: 600; color: rgba(255,255,255,0.55);
  text-transform: uppercase; letter-spacing: 0.05em;
}
.wd__balance-label-ico { color: rgba(201,169,105,0.85); display: flex; }
.wd__balance-live {
  display: inline-flex; align-items: center; gap: 5px; flex-shrink: 0;
  font-size: 9.5px; font-weight: 700; color: #4ADE80;
  background: rgba(74,222,128,0.10); border: 1px solid rgba(74,222,128,0.22);
  border-radius: 20px; padding: 3px 8px;
}
.wd__balance-live-dot { width: 5px; height: 5px; border-radius: 50%; background: #4ADE80; box-shadow: 0 0 5px rgba(74,222,128,0.7); }
.wd__balance-amount {
  position: relative; z-index: 1;
  font-size: 38px; font-weight: 800; line-height: 1.05; margin-top: 10px;
  letter-spacing: -0.03em; font-variant-numeric: tabular-nums;
  background: linear-gradient(180deg, #ffffff 10%, #f0d9a4 95%);
  -webkit-background-clip: text; background-clip: text;
  -webkit-text-fill-color: transparent; color: transparent;
}
.wd__balance-note {
  position: relative; z-index: 1;
  font-size: 11.5px; color: rgba(255,255,255,0.50); line-height: 1.5; margin-top: 8px;
}
.wd__balance-note b { color: #dfc288; font-weight: 700; }
.wd__balance-foot {
  position: relative; z-index: 1; display: flex; flex-wrap: wrap; gap: 6px;
  margin-top: 14px; padding-top: 13px; border-top: 1px solid rgba(201,169,105,0.16);
}
.wd__balance-tag {
  display: inline-flex; align-items: center; gap: 5px;
  font-size: 9.5px; font-weight: 600; color: rgba(255,255,255,0.52);
  background: rgba(255,255,255,0.045); border: 1px solid rgba(255,255,255,0.07);
  border-radius: 20px; padding: 4px 9px;
}
.wd__balance-tag svg { color: rgba(201,169,105,0.8); flex-shrink: 0; }

/* ── Notice / warning ── */
.wd__notice {
  display: flex; align-items: flex-start; gap: 11px;
  margin-top: 14px; padding: 13px 14px;
  background: linear-gradient(150deg, rgba(255,107,92,0.10), rgba(255,107,92,0.03));
  border: 1px solid rgba(255,107,92,0.24); border-radius: 15px;
}
.wd__notice.hidden { display: none; }
.wd__notice-ico {
  flex-shrink: 0; width: 30px; height: 30px; border-radius: 9px;
  background: rgba(255,107,92,0.12); border: 1px solid rgba(255,107,92,0.22);
  display: flex; align-items: center; justify-content: center; color: #ff6b5c;
}
.wd__notice-txt { font-size: 12px; color: rgba(255,255,255,0.62); line-height: 1.55; margin: 0; }
.wd__notice-txt b { color: #ff8b7c; font-weight: 700; }

/* ── Section title ── */
.wd__sec-title {
  display: flex; align-items: center; gap: 9px;
  font-size: 12px; font-weight: 700; letter-spacing: 0.04em; text-transform: uppercase;
  color: rgba(201,169,105,0.72); margin: 22px 4px 11px;
}
.wd__step-n {
  flex-shrink: 0; width: 20px; height: 20px; border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  font-size: 10.5px; font-weight: 800; letter-spacing: 0;
  color: #1a1206; background: linear-gradient(145deg, #f6e3a8, #b8923f);
  box-shadow: 0 3px 8px -3px rgba(201,169,105,0.8);
}

/* ── Withdrawal source segmented control ── */
.wd__src {
  display: flex; gap: 4px; padding: 4px;
  background: rgba(0,0,0,0.34);
  border: 1px solid rgba(255,255,255,0.06);
  border-radius: 14px;
}
.wd__src-tab {
  flex: 1; min-width: 0;
  display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 4px;
  padding: 9px 4px; border: none; border-radius: 11px; cursor: pointer;
  background: transparent; color: rgba(255,255,255,0.44);
  transition: background .2s ease, color .2s ease, box-shadow .2s ease, transform .12s ease;
}
.wd__src-tab:active { transform: scale(0.97); }
.wd__src-ico { display: flex; align-items: center; justify-content: center; }
.wd__src-name { font-size: 10.5px; font-weight: 700; letter-spacing: 0.01em; white-space: nowrap; }
.wd__src-tab--on {
  background: linear-gradient(150deg, rgba(201,169,105,0.28), rgba(201,169,105,0.09));
  color: #f3e0a8;
  box-shadow: inset 0 1px 0 rgba(223,194,136,0.24), 0 6px 14px -9px rgba(201,169,105,0.85);
}
.wd__src-tab--disabled { opacity: 0.32; pointer-events: none; }

/* Principal (capital return) summary */
.wd__prin {
  background: linear-gradient(150deg, rgba(201,169,105,0.10), rgba(201,169,105,0.03));
  border: 1px solid rgba(201,169,105,0.24);
  border-radius: 13px; padding: 13px 14px;
}
.wd__prin-row { display: flex; align-items: baseline; justify-content: space-between; gap: 10px; margin-bottom: 7px; }
.wd__prin-lbl { font-size: 11.5px; color: rgba(255,255,255,0.55); }
.wd__prin-lbl em { font-style: normal; color: rgba(255,255,255,0.38); }
.wd__prin-val { font-size: 15px; font-weight: 800; color: #dfc288; flex-shrink: 0; }
.wd__prin-val--fee { color: #ff8b7c; font-size: 13.5px; }
.wd__prin-note {
  font-size: 10.5px; color: rgba(255,255,255,0.42); line-height: 1.5;
  padding-top: 8px; border-top: 1px solid rgba(201,169,105,0.16);
}
.wd__prin-note--warn { color: rgba(251,191,36,0.85); }

/* ── Commission balance box ── */
.wd__comm-box {
  display: flex; align-items: center; gap: 10px; padding: 13px 14px; border-radius: 13px;
  background: linear-gradient(150deg, rgba(201,169,105,0.12), rgba(201,169,105,0.03));
  border: 1px solid rgba(201,169,105,0.22);
}
.wd__comm-ico {
  width: 34px; height: 34px; border-radius: 10px; flex-shrink: 0;
  display: flex; align-items: center; justify-content: center;
  background: rgba(201,169,105,0.12); border: 1px solid rgba(201,169,105,0.24); color: #dfc288;
}
.wd__comm-txt { flex: 1; min-width: 0; font-size: 12px; color: rgba(255,255,255,0.6); }
.wd__comm-val { font-size: 17px; font-weight: 800; color: #dfc288; flex-shrink: 0; }

/* ── MAX chip + quick fractions ── */
/* width:auto is load-bearing — Framework7 sets a global button rule of width:100%,
   which with flex-shrink:0 makes this chip demand the whole row and squash the input. */
.wd__amount-max {
  flex: 0 0 auto; width: auto;
  padding: 6px 11px; border-radius: 9px; cursor: pointer;
  font-size: 10.5px; font-weight: 800; letter-spacing: 0.05em;
  color: #1a1206; background: linear-gradient(145deg, #f3da92, #b8923f);
  border: none; box-shadow: 0 4px 10px -5px rgba(201,169,105,0.9);
  transition: transform .12s ease, filter .2s ease;
}
.wd__amount-max:active { transform: scale(0.94); filter: brightness(1.08); }
/* locked state — a capital return is always the full principal */
.wd__amount-lock {
  flex: 0 0 auto; display: inline-flex; align-items: center; gap: 5px;
  padding: 5px 10px; border-radius: 9px;
  font-size: 9.5px; font-weight: 800; letter-spacing: 0.06em; text-transform: uppercase;
  color: rgba(223,194,136,0.85);
  background: rgba(201,169,105,0.10); border: 1px solid rgba(201,169,105,0.22);
}
.wd__amount--locked { background: rgba(255,255,255,0.02); border-style: dashed; }
.wd__amount--locked .wd__amount-input { color: rgba(255,255,255,0.75); }
.wd__amount-hint { font-size: 10.5px; color: rgba(255,255,255,0.38); line-height: 1.5; margin: 8px 2px 0; }
.wd__pcts { display: flex; gap: 6px; margin-top: 10px; }
.wd__pct {
  flex: 1; height: 32px; border-radius: 10px; cursor: pointer;
  background: rgba(201,169,105,0.08);
  border: 1px solid rgba(201,169,105,0.18);
  color: rgba(201,169,105,0.88); font-size: 11.5px; font-weight: 700;
  transition: background .16s ease, border-color .16s ease, color .16s ease, transform .1s ease;
}
.wd__pct:active { transform: scale(0.95); }
.wd__pct--on {
  background: linear-gradient(135deg, rgba(201,169,105,0.30), rgba(201,169,105,0.14));
  border-color: rgba(201,169,105,0.5); color: #f3e0a8;
  box-shadow: inset 0 1px 0 rgba(223,194,136,0.25);
}

/* ── Payout accounts (beneficiaries) ── */
.wd__payout { margin-top: 16px; }
.wd__payout-head { display: flex; align-items: center; justify-content: space-between; margin: 0 2px 10px; }
.wd__payout-title { font-size: 11px; font-weight: 600; letter-spacing: 0.03em; text-transform: uppercase; color: rgba(201,169,105,0.78); }
/* dashed "add account" button (rendered inside the list / empty state) */
.wd__bene-add-btn {
  width: 100%; height: 46px; margin-top: 11px; cursor: pointer;
  display: flex; align-items: center; justify-content: center; gap: 7px;
  border: 1.4px dashed rgba(201,169,105,0.4); border-radius: 13px;
  background: rgba(201,169,105,0.06); color: #dfc288; font-size: 13px; font-weight: 700;
}
.wd__bene-add-btn:active { transform: scale(0.99); background: rgba(201,169,105,0.12); }
.wd__bene-empty .wd__bene-add-btn { margin-top: 14px; }

.wd__bene-list { display: flex; flex-direction: column; gap: 9px; }
.wd__bene {
  position: relative; display: flex; align-items: center; gap: 12px; cursor: pointer;
  padding: 13px 13px; border-radius: 14px;
  background: rgba(255,255,255,0.03); border: 1.5px solid rgba(255,255,255,0.08);
  transition: border-color .16s ease, background .16s ease;
}
.wd__bene-radio { position: absolute; opacity: 0; pointer-events: none; }
.wd__bene--on { border-color: rgba(201,169,105,0.55); background: linear-gradient(155deg, rgba(201,169,105,0.14), rgba(201,169,105,0.04)); }
.wd__bene-ico {
  width: 38px; height: 38px; border-radius: 11px; flex-shrink: 0;
  display: flex; align-items: center; justify-content: center;
  background: rgba(201,169,105,0.1); border: 1px solid rgba(201,169,105,0.2); color: #dfc288;
}
.wd__bene--on .wd__bene-ico { background: linear-gradient(135deg, #f3da92, #C9A969); color: #1a1206; border-color: transparent; }
.wd__bene-main { flex: 1; min-width: 0; }
.wd__bene-title { display: block; font-size: 13.5px; font-weight: 700; color: #fff; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.wd__bene-sub { display: block; font-size: 11px; color: rgba(255,255,255,0.45); margin-top: 2px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.wd__bene-check {
  width: 22px; height: 22px; border-radius: 50%; flex-shrink: 0;
  display: flex; align-items: center; justify-content: center;
  border: 1.5px solid rgba(255,255,255,0.18); color: transparent; transition: all .16s ease;
}
.wd__bene--on .wd__bene-check { background: #4ade80; border-color: #4ade80; color: #06320f; }
.wd__bene-del {
  width: 30px; height: 30px; border-radius: 9px; flex-shrink: 0; cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  background: rgba(255,107,92,0.08); border: 1px solid rgba(255,107,92,0.2); color: #ff6b5c;
}
.wd__bene-del:active { transform: scale(0.92); }

/* empty state */
.wd__bene-empty {
  text-align: center; padding: 22px 16px; border-radius: 14px;
  background: rgba(255,255,255,0.025); border: 1.4px dashed rgba(201,169,105,0.3);
}
.wd__bene-empty-ico {
  width: 46px; height: 46px; border-radius: 13px; margin: 0 auto 11px;
  display: flex; align-items: center; justify-content: center;
  background: rgba(201,169,105,0.08); border: 1px solid rgba(201,169,105,0.18); color: rgba(201,169,105,0.75);
}
.wd__bene-empty-txt { font-size: 12.5px; color: rgba(255,255,255,0.55); line-height: 1.5; margin: 0; }
.wd__bene-empty-txt b { color: rgba(201,169,105,0.9); }

/* inline add form */
.wd__bene-form {
  margin-top: 12px; padding: 15px 14px; border-radius: 15px;
  background: rgba(0,0,0,0.22); border: 1px solid rgba(201,169,105,0.2);
}
.wd__bene-form-title { font-size: 12.5px; font-weight: 800; color: #f3e2b6; margin: 0 0 13px; display: flex; align-items: center; gap: 7px; }
.wd__bene-form .wd__field { margin-bottom: 12px; }
.wd__bene-form .wd__field:last-of-type { margin-bottom: 0; }
.wd__bene-row { display: flex; gap: 10px; }
.wd__bene-row .wd__field { flex: 1; min-width: 0; }
.wd__net-tabs.wd__net-tabs--sm { gap: 8px; }
.wd__bene-form-actions { display: flex; gap: 9px; margin-top: 14px; }
.wd__bene-cancel {
  flex: 1; height: 46px; border-radius: 12px; cursor: pointer;
  background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1);
  color: rgba(255,255,255,0.65); font-size: 13.5px; font-weight: 700;
}
.wd__bene-save {
  flex: 2; height: 46px; border: none; border-radius: 12px; cursor: pointer;
  display: flex; align-items: center; justify-content: center; gap: 7px;
  background: linear-gradient(135deg, #f3da92 0%, #C9A969 45%, #a07c38 100%);
  color: #1a1206; font-size: 13.5px; font-weight: 800;
}
.wd__bene-save:active, .wd__bene-cancel:active { transform: scale(0.98); }
.wd__bene-save.disabled { opacity: 0.5; pointer-events: none; }

/* ── Form card ── */
.wd__card {
  background: linear-gradient(155deg, #161513 0%, #121110 100%);
  border: 1px solid rgba(201,169,105,0.14);
  border-radius: 18px; padding: 16px 14px 14px;
  box-shadow: inset 0 1px 0 rgba(201,169,105,0.10), 0 14px 30px -18px rgba(0,0,0,0.7);
}
.wd__field { margin-bottom: 14px; }
.wd__field select, .selectBeneficiaryList select { width: 100%; }
.wd__card .select2-container { width: 100% !important; display: block; }
.wd__field-lbl, .wd__sub-lbl {
  display: block; font-size: 11px; font-weight: 600; letter-spacing: 0.03em;
  text-transform: uppercase; color: rgba(201,169,105,0.78) !important; margin: 0 2px 8px;
}
/* amount + generic inputs */
.wd__amount, .wd__input {
  display: flex; align-items: center; gap: 8px;
  background: rgba(255,255,255,0.04); border: 1px solid rgba(201,169,105,0.18);
  border-radius: 13px; padding: 0 14px; height: 52px;
  transition: border-color .18s ease, background .18s ease;
}
.wd__amount:focus-within, .wd__input:focus-within { border-color: rgba(201,169,105,0.5); background: rgba(255,255,255,0.06); }
.wd__amount-cur { font-size: 18px; font-weight: 700; color: rgba(201,169,105,0.85); }
.wd__input-ico { color: rgba(201,169,105,0.7); display: flex; }
.wd__amount input, .wd__input input {
  flex: 1 1 0; width: 0; min-width: 0; background: transparent; border: none; outline: none;
  color: #fff; height: 100%; -webkit-appearance: none; appearance: none; margin: 0;
}
.wd__amount-input::-webkit-outer-spin-button, .wd__amount-input::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
.wd__amount input { font-size: 19px; font-weight: 700; }
.wd__input input { font-size: 15px; font-weight: 600; }
.wd__amount input::placeholder, .wd__input input::placeholder { color: rgba(255,255,255,0.28); font-weight: 600; }
/* INR conversion (Bank/UPI · India) */
.wd__inr {
  display: flex; align-items: center; justify-content: space-between; gap: 8px;
  margin: 9px 2px 0; padding: 9px 12px; border-radius: 11px;
  background: rgba(201,169,105,0.07); border: 1px solid rgba(201,169,105,0.16);
}
.wd__inr-amt { font-size: 13px; color: rgba(255,255,255,0.6); }
.wd__inr-amt b { color: #dfc288; font-weight: 800; font-size: 14px; }
.wd__inr-rate { font-size: 10.5px; color: rgba(255,255,255,0.4); }
.wd__inr-rate span { color: rgba(201,169,105,0.85); font-weight: 600; }
/* ── Withdrawal fee breakdown — styled as a receipt ── */
.wd__fee-row {
  position: relative;
  margin-top: 13px; padding: 13px 14px; border-radius: 14px;
  background: rgba(0,0,0,0.26);
  border: 1px solid rgba(255,255,255,0.06);
}
.wd__fee-line { display: flex; align-items: baseline; justify-content: space-between; gap: 12px; padding: 4px 0; }
.wd__fee-line-lbl { font-size: 11.5px; color: rgba(255,255,255,0.50); }
.wd__fee-em { font-style: normal; color: rgba(255,255,255,0.34); font-size: 10.5px; }
.wd__fee-line-val { font-size: 12.5px; font-weight: 700; color: rgba(255,255,255,0.86); font-variant-numeric: tabular-nums; }
.wd__fee-line-val--fee { color: #ff8b7c; }
/* perforated tear line, like a paper receipt */
.wd__fee-divider {
  height: 1px; margin: 8px -14px;
  background-image: linear-gradient(90deg, rgba(255,255,255,0.16) 55%, transparent 0);
  background-size: 7px 1px; background-repeat: repeat-x;
}
.wd__fee-line--net { padding-top: 2px; }
.wd__fee-line-lbl--net {
  display: inline-flex; align-items: center; gap: 6px;
  font-size: 12px; font-weight: 700; color: #4ADE80;
}
.wd__fee-line-val--net {
  font-size: 17px; font-weight: 800; color: #4ADE80; letter-spacing: -0.01em;
}

/* method selector */
.wd__methods { display: flex; flex-direction: column; gap: 8px; }
.wd__method {
  width: 100%; display: flex; align-items: center; gap: 11px; text-align: left;
  padding: 12px; border-radius: 14px; cursor: pointer;
  background: linear-gradient(155deg, rgba(255,255,255,0.05), rgba(255,255,255,0.012));
  border: 1.5px solid rgba(255,255,255,0.07);
  transition: background .2s ease, border-color .2s ease, box-shadow .2s ease, transform .12s ease;
}
.wd__method:active { transform: scale(0.99); }
.wd__method-body { flex: 1; min-width: 0; }
.wd__method-name { display: block; font-size: 13.5px; font-weight: 800; color: rgba(255,255,255,0.92); }
.wd__method-tag { display: block; font-size: 10px; color: rgba(255,255,255,0.38); margin-top: 2px; }
.wd__method-check {
  flex-shrink: 0; width: 20px; height: 20px; border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  background: rgba(255,255,255,0.06); color: transparent;
  border: 1px solid rgba(255,255,255,0.10);
  transition: background .2s ease, color .2s ease, border-color .2s ease;
}
.wd__method--on {
  background: linear-gradient(150deg, rgba(201,169,105,0.20), rgba(201,169,105,0.05));
  border-color: rgba(201,169,105,0.55);
  box-shadow: inset 0 1px 0 rgba(223,194,136,0.20), 0 8px 20px -14px rgba(201,169,105,0.9);
}
.wd__method--on .wd__method-check {
  background: linear-gradient(145deg, #f6e3a8, #a07c38); color: #1a1206; border-color: transparent;
}
.wd__method--on .wd__method-tag { color: rgba(223,194,136,0.72); }

/* real logo (e.g. USDT) — white tile so the brand color shows, even when active */
.wd__method-ico {
  flex-shrink: 0; width: 38px; height: 38px; border-radius: 11px;
  display: flex; align-items: center; justify-content: center;
  background: rgba(255,255,255,0.06); color: rgba(255,255,255,0.7);
  border: 1px solid rgba(255,255,255,0.08);
}
.wd__method--on .wd__method-ico { border-color: rgba(201,169,105,0.30); color: #dfc288; }
/* real logo tile stays white so the brand colour reads, active or not */
.wd__method-ico--logo, .wd__method--on .wd__method-ico--logo { background: #fff; padding: 4px; }
.wd__method-ico--logo img { width: 100%; height: 100%; object-fit: contain; display: block; box-sizing: border-box; }
.wd__method--on .wd__method-name { color: #fff; }
.wd__method--on .wd__method-tag { color: rgba(223,194,136,0.85); }

/* USDT network tabs */
.wd__net-tabs { display: flex; gap: 8px; }
.wd__net-tab {
  flex: 1; cursor: pointer; padding: 11px 8px; border-radius: 11px;
  background: rgba(255,255,255,0.03); border: 1.5px solid rgba(255,255,255,0.08);
  color: rgba(255,255,255,0.6); font-size: 12px; font-weight: 700;
  transition: all .16s ease;
}
.wd__net-tab--on {
  background: linear-gradient(155deg, rgba(201,169,105,0.18), rgba(201,169,105,0.05));
  border-color: rgba(201,169,105,0.5); color: #dfc288;
}

/* hints */
.wd__hint { font-size: 11.5px; color: rgba(255,255,255,0.45); line-height: 1.55; margin: 10px 2px 0; }
.wd__hint b { color: rgba(201,169,105,0.9); font-weight: 700; }
.wd__hint--warn { color: rgba(255,255,255,0.55); }
.wd__hint--warn b { color: #ff8b7c; }

.wd__card .list { margin: 0; background: transparent; }
.wd__card .list ul { background: transparent; }
.wd__card .list ul::before, .wd__card .list ul::after { display: none; }
.wd__card .item-content { padding-left: 0; }
.wd__card .item-inner { padding-right: 0; }
/* float-label pills: blend with dark inputs (was white) */
.wd__card .item-floating-label { background: transparent !important; color: rgba(201,169,105,0.85) !important; }
.wd__card .item-label { color: rgba(201,169,105,0.85) !important; }
.wd__card input[type="text"], .wd__card input[type="tel"], .wd__card input[type="email"],
.wd__card input[type="password"], .wd__card input[type="number"] { color: #fff !important; }

/* add beneficiary button */
.wd__add-btn {
  width: 100%; height: 46px; border-radius: 12px !important;
  border: 1px dashed rgba(201,169,105,0.4) !important; color: var(--gold) !important;
  background: rgba(201,169,105,0.05) !important; font-weight: 700; font-size: 13px;
}

/* time / weekend text */
.wd__timetxt:empty { display: none; }
.wd__timetxt {
  margin: 6px 2px 0; font-size: 11.5px; line-height: 1.5;
  color: #ff8b7c; font-weight: 600;
}

/* submit */
.wd__submit {
  width: 100%; min-height: 54px; margin: 16px 0 2px; border: none; border-radius: 15px;
  display: flex; align-items: center; justify-content: center; gap: 8px; cursor: pointer;
  padding: 12px 16px;
  background: linear-gradient(135deg, #f3da92 0%, #C9A969 45%, #a07c38 100%);
  color: #1a1206;
  box-shadow: 0 10px 26px -8px rgba(201,169,105,0.6), inset 0 1px 0 rgba(255,255,255,0.4);
  transition: transform 0.14s, opacity 0.2s, filter 0.2s;
}
.wd__submit:active { transform: scale(0.98); }
.wd__submit.disabled { opacity: 0.45; filter: grayscale(0.3); pointer-events: none; box-shadow: none; }
.wd__submit-body { display: flex; flex-direction: column; align-items: center; gap: 2px; }
.wd__submit-txt { font-size: 15px; font-weight: 800; }
.wd__submit-sub { font-size: 11.5px; font-weight: 600; opacity: 0.75; }
.wd__submit-sub b { font-weight: 800; opacity: 1; }

/* ── Info rules ── */
.wd__info {
  margin-top: 16px; padding: 14px;
  background: linear-gradient(155deg, rgba(255,255,255,0.04), rgba(255,255,255,0.012));
  border: 1px solid rgba(255,255,255,0.06);
  border-radius: 18px;
}
.wd__rule { display: flex; align-items: flex-start; gap: 10px; padding: 9px 0; }
.wd__rule + .wd__rule { border-top: 1px solid rgba(255,255,255,0.05); }
.wd__rule:first-child { padding-top: 0; }
.wd__rule:last-child { padding-bottom: 0; }
.wd__rule-ico {
  flex-shrink: 0; width: 24px; height: 24px; border-radius: 8px; margin-top: 1px;
  display: flex; align-items: center; justify-content: center;
  background: rgba(201,169,105,0.10); color: rgba(201,169,105,0.9);
  border: 1px solid rgba(201,169,105,0.18);
}
.wd__rule-txt { font-size: 11.5px; color: rgba(255,255,255,0.52); line-height: 1.55; }
.wd__rule-txt b { color: rgba(223,194,136,0.92); font-weight: 700; }

/* ── Compatible wallets ── */
.wd__wallets {
  margin-top: 16px; padding: 15px 14px;
  background: linear-gradient(155deg, #161513 0%, #121110 100%);
  border: 1px solid rgba(201,169,105,0.12); border-radius: 18px;
  box-shadow: inset 0 1px 0 rgba(201,169,105,0.10), 0 12px 28px -18px rgba(0,0,0,0.7);
}
.wd__wallets-head { display: flex; align-items: center; gap: 11px; margin-bottom: 14px; }
.wd__wallets-ico {
  width: 34px; height: 34px; border-radius: 10px; flex-shrink: 0;
  display: flex; align-items: center; justify-content: center;
  background: rgba(201,169,105,0.10); border: 1px solid rgba(201,169,105,0.18); color: #dfc288;
}
.wd__wallets-head-txt { display: flex; flex-direction: column; gap: 2px; min-width: 0; }
.wd__wallets-title { font-size: 13.5px; font-weight: 800; color: #fff; }
.wd__wallets-sub { font-size: 11px; color: rgba(255,255,255,0.5); line-height: 1.4; }
.wd__wallets-sub b { color: rgba(223,194,136,0.92); font-weight: 700; }
/* marquee viewport + edge fades */
.wd__wallets-marquee { position: relative; overflow: hidden; }
.wd__wallets-marquee::before, .wd__wallets-marquee::after {
  content: ''; position: absolute; top: 0; bottom: 0; width: 42px; z-index: 2; pointer-events: none;
}
.wd__wallets-marquee::before { left: 0;  background: linear-gradient(90deg, #15130f, rgba(21,19,15,0)); }
.wd__wallets-marquee::after  { right: 0; background: linear-gradient(270deg, #131110, rgba(19,17,16,0)); }
.wd__wallets-track {
  display: flex; width: max-content; padding: 2px 0;
  animation: wd-marquee 26s linear infinite; will-change: transform;
}
.wd__wallets-marquee:active .wd__wallets-track { animation-play-state: paused; }
@keyframes wd-marquee { from { transform: translateX(0); } to { transform: translateX(-50%); } }
.wd__wallets-track .wd__wallet { margin-right: 8px; flex-shrink: 0; }
.wd__wallet {
  display: inline-flex; align-items: center; gap: 8px;
  padding: 7px 12px 7px 7px; border-radius: 12px;
  background: rgba(255,255,255,0.035); border: 1px solid rgba(255,255,255,0.07);
}
.wd__wallet-logo {
  width: 28px; height: 28px; border-radius: 8px; flex-shrink: 0;
  box-sizing: border-box; padding: 3px; object-fit: contain;
  background: #fff; box-shadow: 0 2px 6px rgba(0,0,0,0.35);
}
.wd__wallet-name { font-size: 12px; font-weight: 700; color: rgba(255,255,255,0.82); white-space: nowrap; }

.wd__end-gap { height: 40px; }
`,
  styleScoped: false
};